import React, {useMemo} from 'react'
import {useSearchParams} from 'react-router-dom'
import useQueryAbnormal from '../../../hooks/api/abnormal/useQueryAbnormal'
import AssetContainer from '../user/AssetContainer'
import PageLayout from '../../../components/layout/PageLayout'
import {ILatestBalance} from '../../../apis/user/getKeyProfile'
import {useDisplayNumber} from '../../../utils/number'
import AbnormalInfoContainer from './AbnormalInfoContainer'
import PositionContainer from '../user/PositionContainer'
import KeyInfoContainer from '../user/KeyInfoContainer'
import useQueryKeyDetail from '../../../hooks/api/user/userQueryApiDetail'
import {IOrder} from '../../../apis/unknownorder/nft'
import OrderContainer from '../../../components/table/OrderContainer'

interface IProps {
    className?: string
}

const AbnormalDetail: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const id = searchParams.get('id')
    const {data} = useQueryAbnormal(id)
    const {floorBalance} = useDisplayNumber()
    const {data: keyInfo, refetch} = useQueryKeyDetail(data?.data?.key_id)

    const nextBalance = useMemo<ILatestBalance>(() => {
        return data?.data?.next_balance
    }, [data])

    const prevBalance = useMemo<ILatestBalance>(() => {
        return data?.data?.prev_balance
    }, [data])

    const orders = useMemo<IOrder[]>(() => {
        return data?.data?.orders
    }, [data])

    return (
        <PageLayout title="Abnormal Detail">
            <KeyInfoContainer data={keyInfo} hasDetail={false} />
            <AbnormalInfoContainer
                className={'space-y-[30px]'}
                data={data?.data?.unknown_transfer}
                yesterdayTotal={data?.data?.yesterday_total}
                todayTotal={data?.data?.today_total}
            />
            <OrderContainer data={orders} />
            <div className={'grid-cols-2 grid gap-[30px] lg:block lg:space-y-[30px]'}>
                <AssetContainer total={prevBalance?.total_amount_in_base} subTitle="Prev" data={prevBalance?.assets} />
                <AssetContainer total={nextBalance?.total_amount_in_base} subTitle="Next" data={nextBalance?.assets} />
            </div>
            <div className={'grid-cols-2 grid gap-[30px] lg:block lg:space-y-[30px]'}>
                <PositionContainer data={prevBalance?.current_position} />
                <PositionContainer data={nextBalance?.current_position} />
            </div>
        </PageLayout>
    )
}

export default AbnormalDetail
